
export const SET_AUTH = 'SET_AUTH';
export const RESET_REDUX_STORE = 'RESET_REDUX_STORE';
